import { HTMLAttributes } from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';

import { wacToken } from '@/libraries/design/foundations/index.ts';

// Only layout/border CSS — content styling is the responsibility of slot children
const cellCss = css({
	display: 'table-cell',
	verticalAlign: 'top',
	padding: '14px',
	borderInlineEnd: `1px solid ${wacToken('color.neutral.light400')}`,
	':last-of-type': {
		borderInlineEnd: 'none',
	},
	[media.below.sm]: {
		display: 'none',
	},
});

export const GenericTableCustomCell = (props: HTMLAttributes<HTMLTableCellElement>) => {
	return <td {...props} css={cellCss} />;
};
